import { MyleHelper } from "@/Common/Helpers/MyleHelper";

class TimeSpan {
    public ticks: number;

    constructor(days: number = 0, hours: number = 0, minutes: number = 0, seconds: number = 0) {
        this.ticks = 0;
        this.ticks += this.daysToTicks(days);
        this.ticks += this.hoursToTicks(hours);
        this.ticks += this.minutesToTicks(minutes);
        this.ticks += this.secondsToTicks(seconds);
    }

    public static FromTicksStr(ticks: string): TimeSpan {
        let timeSpan = new TimeSpan(0, 0, 0, 0);
        timeSpan.ticks = Number(ticks);
        return timeSpan;
    }

    public static FromTicks(ticks: number): TimeSpan {
        let timeSpan = new TimeSpan(0, 0, 0, 0);
        timeSpan.ticks = ticks;
        return timeSpan;
    }

    public toString(format: string): string {
        if (format == null)
            return "";

        let days = Math.floor(this.ticks / this.daysToTicks(1)).toString();
        format = format.replaceAll("dd", days);

        let hoursRaw = Math.floor(this.ticks % this.daysToTicks(1) / this.hoursToTicks(1));
        if (hoursRaw == 0) {
            format = format.replaceAll(MyleHelper.EscapeRegExp("hh?:"), "");
            format = format.replaceAll(MyleHelper.EscapeRegExp("HH?:"), "");
        }
        else {
            format = format.replaceAll(MyleHelper.EscapeRegExp("hh?"), "hh");
            format = format.replaceAll(MyleHelper.EscapeRegExp("HH?"), "HH");
        }

        let hours24 = hoursRaw.toString().padLeft("0", 2);
        format = format.replaceAll("HH", hours24);

        let hours12 = (hoursRaw % 12).toString().padLeft("0", 2);
        format = format.replaceAll("hh", hours12);

        let mins = Math.floor(this.ticks % this.hoursToTicks(1) / this.minutesToTicks(1)).toString().padLeft("0", 2);
        format = format.replaceAll("mm", mins);

        let secs = Math.floor(this.ticks % this.minutesToTicks(1) / this.secondsToTicks(1)).toString().padLeft("0", 2);
        format = format.replaceAll("ss", secs);

        return format;
    }

    public AddSeconds(secs: number): void {
        this.ticks += this.secondsToTicks(secs);
    }
    public AddMinutes(mins: number): void {
        this.ticks += this.minutesToTicks(mins);
    }
    public AddHours(hours: number): void {
        this.ticks += this.hoursToTicks(hours);
    }
    public AddDays(days: number): void {
        this.ticks += this.daysToTicks(days);
    }

    public TotalDays(): number {
        return Math.round(this.ticks / this.daysToTicks(1));
    }
    public TotalMinutes(): number {
        return Math.round(this.ticks / this.minutesToTicks(1));
    }
    public TotalSeconds(): number {
        return Math.round(this.ticks / this.secondsToTicks(1));
    }

    private secondsToTicks(sec: number): number {
        return Math.round(sec * 10000000);
    }
    private minutesToTicks(mins: number): number {
        return this.secondsToTicks(mins * 60);
    }
    private hoursToTicks(hours: number): number {
        return this.minutesToTicks(hours * 60);
    }
    private daysToTicks(days: number): number {
        return this.hoursToTicks(days * 24);
    }
}

export { TimeSpan };
